export const selectBrandMarketGeneralSettings = (state) => state.marketGeneralSettings;

export const selectBrandVerificationConfigurations = (state) => state.verificationConfigurations;

export const selectBrandVerificationDocumentTypes = (state) => state.verificationDocumentTypes;

export const selectBrandVerificationPeriod = (state) => state.verificationPeriod;

export const selectBrandUnverifiedPlayersDepositLimits = (state) => state.unverifiedPlayersDepositLimits;
